import { useEffect } from 'react';

const LazyLoadMap = () => {
  useEffect(() => {
    // IntersectionObserver for lazy-loading
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const iframe = document.createElement('iframe');
          iframe.src = entry.target.dataset.src;
          entry.target.appendChild(iframe);
          observer.unobserve(entry.target);
        }
      });
    });

    const lazyLoadMapElements = document.querySelectorAll('.lazy-load-map');
    lazyLoadMapElements.forEach((element) => {
      observer.observe(element);
    });

    // Add event listeners
    document.addEventListener('touchstart', touchStartHandler, {
      passive: true,
    });
    document.addEventListener('touchmove', touchMoveHandler, { passive: true });
    document.addEventListener('wheel', wheelHandler, { passive: true });

    function touchStartHandler(event) {}

    function touchMoveHandler(event) {}

    function wheelHandler(event) {}

    // Cleanup
    return () => {
      lazyLoadMapElements.forEach((element) => {
        observer.unobserve(element);
      });
      document.removeEventListener('touchstart', touchStartHandler);
      document.removeEventListener('touchmove', touchMoveHandler);
      document.removeEventListener('wheel', wheelHandler);
    };
  }, []);

  return (
    <div
      className='lazy-load-map'
      data-src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2915.3283122268836!2d-89.52742032324863!3d43.05556207113677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8807f4e8007f5ff1%3A0x403d4bc9cc7cd6cc!2sThe%20Cider%20Farm!5e0!3m2!1sen!2sus!4v1697596844053!5m2!1sen!2sus'
    ></div>
  );
};

export default LazyLoadMap;
